import { render, staticRenderFns } from "./faceLibrary.vue?vue&type=template&id=d0ac3440&scoped=true"
import script from "./faceLibrary.vue?vue&type=script&lang=js"
export * from "./faceLibrary.vue?vue&type=script&lang=js"
import style0 from "./faceLibrary.vue?vue&type=style&index=0&id=d0ac3440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ac3440",
  null
  
)

export default component.exports